import { getOrderTypeConfig, type InitialCartState, isGroupOrder } from '@commerce-cart-webcomponents/sdk';
import type { AppState } from '@nextgen-web-framework/core';
import { useSelector } from 'react-redux';
import { useSession } from '@nextgen-web-framework/all';
import {
  AddToListButton,
  AddToCartButton,
  AddToCartWithStepper,
  AddToCartDrawer,
  AddToCartWithSubscribe,
} from '@commerce-cart-webcomponents/ui';
import styles from './AddToCartOrGroupCart.module.scss';
import { AddToCartOrGroupCartProps } from './types/propsType';
import { AddToCartButtonType } from './types/enums';

export function AddToCartOrGroupCart(props: AddToCartOrGroupCartProps) {
  const commerceCartState = useSelector((state: AppState) => state.commerceCart);
  const { cart }: InitialCartState = commerceCartState;
  const { isABO } = useSession();
  const orderType = getOrderTypeConfig();

  const buttonTypeHandler = () => {
    const showDrawer = isGroupOrder(cart.id === '' ? orderType : cart.orderType);
    const buttonCondition =
      props.addToCartButtonType !== (AddToCartButtonType.ADD_TO_LIST_BUTTON as string) &&
      props.addToCartButtonType !== (AddToCartButtonType.ADD_TO_CART_WITH_SUBSCRIBE as string);
    if (isABO() && showDrawer && buttonCondition) {
      return <AddToCartDrawer {...props} />;
    } else if (props.addToCartButtonType === AddToCartButtonType.ADD_TO_CART_BUTTON) {
      return <AddToCartButton {...props} />;
    } else if (props.addToCartButtonType === AddToCartButtonType.ADD_TO_LIST_BUTTON) {
      return <AddToListButton {...props} />;
    } else if (props.addToCartButtonType === AddToCartButtonType.ADD_TO_CART_WITH_SUBSCRIBE) {
      return <AddToCartWithSubscribe {...props} />;
    } else {
      return <AddToCartWithStepper {...props} />;
    }
  };

  return <div className={styles['add-to-cart-group-cart-container']}>{buttonTypeHandler()}</div>;
}

export type { AddToCartOrGroupCartProps };
export { AddToCartButtonType };
